import { FlexRow } from '@/components/common/Flex';
import { Paragraph } from '@/components/common/Typography';
import { Circle } from '@chakra-ui/react';
import { useTags } from '@common/react/cashflow';

const TagValues = ({ tagNames }: { tagNames: string[] }) => {
    const { tags } = useTags();

    const tagLabels = tagNames.map((tagName) => {
        const tag = tags.find((tag) => tag.name === tagName);

        if (tag) {
            return (
                <FlexRow
                    key={tagName}
                    align="center"
                    gap={2}
                    bg="gray.100"
                    borderRadius="md"
                    py={1}
                    px={2}
                >
                    <Circle size={2} bg={tag.color} />
                    <Paragraph>{tagName}</Paragraph>
                </FlexRow>
            );
        }
    });

    return (
        <FlexRow wrap="wrap" gap={2}>
            {tagLabels}
        </FlexRow>
    );
};

export default TagValues;
